import { render, staticRenderFns } from "./drop-file.vue?vue&type=template&id=50b248d9&scoped=true&"
import script from "./drop-file.vue?vue&type=script&lang=js&"
export * from "./drop-file.vue?vue&type=script&lang=js&"
import style0 from "./drop-file.vue?vue&type=style&index=0&id=50b248d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b248d9",
  null
  
)

export default component.exports